export enum CallToActionType {
    NONE = 'none',
    URL = 'url',
    SITEMAP_PAGE = 'sitemap_page',
    PRODUCT = 'product',
    CATALOG_BRAND = 'catalog_brand',
    CATALOG_CATEGORY = 'catalog_category',
    CATALOG_COLLECTION = 'catalog_collection',
    CATALOG_LABEL = 'catalog_label',
}

export enum Theme {
    LIGHT = 'light',
    DARK = 'dark',
    NONE = 'none'
}

export enum Align {
    LEFT = 'left',
    RIGHT = 'right',
    CENTER = 'center',
}

export enum MediaType {
    IMAGE = 'image',
    VIDEO = 'video',
}

export enum Layout {
    HORISONTAL = 'horisontal',
    VERTICAL = 'vertical',
    SIMPLE = 'simple',
}

export enum DraftSlugs {
    PREVIEW = 'preview',
    SITEMAP = 'sitemap-page'
}

export enum Lang {
    ENGLISH = 'en',
    SERBIAN = 'sr'
}

export enum NumberValuesForBoolean {
    TRUE = 1,
    FALSE = 0
}

export enum PriceTypes {
    PRICE_MONTHLY_OPTION = 'monthly',
    PRICE_ONE_TIME_OPTION = 'one_time'
}

export enum RoutesKeys {
    NEWS = '/news',
    NEWS_SLUG = '/news/:seo_slug',
    PRODUCTS = '/products',
    PRODUCTS_ID = '/products/:id'
}

export enum UTM_PARAMS {
    UTM_ID = 'utm_id',
    UTM_SOURCE = 'utm_source',
    UTM_CONTENT = 'utm_content',
    UTM_MEDIUM = 'utm_medium',
    UTM_CAMPAIGN = 'utm_campaign',
    UTM_TERM = 'utm_term',
    UTM_DATE = 'utm_date',
    PARTNER_ID = 'partner_id',
    FULL_SLUG_WITH_PARAMS = 'full_slug_with_params'
}

export enum ServiceErrors {
    EMAIL_VERIFICATION_FAILED = 'EMAIL_VERIFICATION_FAILED',
    CONTRACT_LIMIT_REACHED = 'CONTRACT_LIMIT_REACHED',
    CREDIT_RATING_CHECK_FAILED = 'CREDIT_RATING_CHECK_FAILED',
    CUSTOMER_SEPA_CHECK_FAILED = 'CUSTOMER_SEPA_CHECK_FAILED',
    MOBILE_PREPAID_REGISTRATION_MSISDN_CHECK_FAILED = 'MOBILE_PREPAID_REGISTRATION_MSISDN_CHECK_FAILED',
    PUK_CODE_IS_NOT_VALID = 'PUK_CODE_IS_NOT_VALID',
    RESIDENCE_ADDRESS_VERIFICATION_FAILED = 'RESIDENCE_ADDRESS_VERIFICATION_FAILED',
    DELIVERY_ADDRESS_VERIFICATION_FAILED = 'DELIVERY_ADDRESS_VERIFICATION_FAILED',
    MOBILE_PREPAID_REGISTRATION_USER_DOESNT_EXIST = 'MOBILE_PREPAID_REGISTRATION_USER_DOESNT_EXIST',
    MOBILE_PREPAID_REGISTRATION_USER_TARIFF_IS_PREPAID = 'MOBILE_PREPAID_REGISTRATION_USER_TARIFF_IS_PREPAID',
    MOBILE_PREPAID_REGISTRATION_MOBILE_TARIFF_DOESNT_EXIST = 'MOBILE_PREPAID_REGISTRATION_MOBILE_TARIFF_DOESNT_EXIST',
    MOBILE_TOPUP_MSISDN_CHECK_FAILED = 'MOBILE_TOPUP_MSISDN_CHECK_FAILED',
    COUPON_MUST_HAVE_16_DIGIT_CHARACTERS = "COUPON_MUST_HAVE_16_DIGIT_CHARACTERS",
    MOBILE_TOPUP_COUPON_FAILED = "MOBILE_TOPUP_COUPON_FAILED",
    PHONE_NUMBER_IS_NOT_VALID = "PHONE_NUMBER_IS_NOT_VALID",
    CUSTOMER_ALREADY_EXISTS = "CUSTOMER_ALREADY_EXISTS",
    SOMETHING_WENT_WRONG = "SOMETHING_WENT_WRONG",
    SALUTATION_NOT_VALID = "SALUTATION_NOT_VALID",
    SOMETHING_WENT_WRONG_CITIES = "SOMETHING_WENT_WRONG_CITIES",
    SOMETHING_WENT_WRONG_STREETS = "SOMETHING_WENT_WRONG_STREETS",
}

export enum CrmErrors {
    REQUEST_ALREADY_SENT = "REQUEST_ALREADY_SENT"
}

export enum TechErrorCodes {
    STB_COUNT_EXCEEDED = 40,
    PREPAID_SIM_COUNT_ERROR = 41,
    SIM_COUNT_NOT_AVAILABLE = 42,
    INCOMPLETE_DATA = 43,
    NOT_VALID_DOCUMENT = 44,
    INVALID_ADDRESS = 45,
    CONSENTS_LACKING = 46,
    CREDIT_RATING_CHECK_FAILED = 47,
    WRONG_CHECKOUT = 48,
}

export enum PreviewEntities {
    SITEMAP_PAGE = 'content-sitemap-pages',
    PRODUCT = 'products',
    NEWS = 'news'
}


